import type { TeamDTOV2 } from '@/common/types/teams.ts'
import HttpService from '@/common/services/HttpService'

const serviceV2Root = '/api/v2/teams'

export const getTeamsV2 = async (): Promise<TeamDTOV2[]> => {
  return HttpService.getData<TeamDTOV2[]>(serviceV2Root, {
    params: {
      'include-deactivated': true,
    },
  })
}
